<template>
  <div id="contenedor-perfil-usuario-default">
    <v-container fluid>
      <v-card class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Perfil de Usuario"></titulo-tool-bar>
          <!-- <tool-bar
            class="mb-4"
            v-on:editarUsuario="abrirEditarUsuario"
            >
          </tool-bar> -->
        </v-card-text>
      </v-card>
      <v-card flat
        v-if="$auth.user.id">
        <v-card-text>
          <perfil-usuario
          :usuarioId="$auth.user.id">
          </perfil-usuario>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>

// import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
// import ToolBar from './ToolBar.vue';
import PerfilUsuario from '@/components/administracion/configuracion/catalogos/usuarios/PerfilUsuario.vue';
// import eventBus from '@/helpers/eventBus';

export default {
  name: 'PerfilUsuarioDefault',
  components: {
    TituloToolBar,
    // ToolBar,
    PerfilUsuario,
  },
  data() {
    return {
      mostrarVentanaEditarUsuario: false,
      esteUsuario: null,
    };
  },
  methods: {
    abrirEditarUsuario() {
      this.mostrarVentanaEditarUsuario = true;
    },
    cerrarVentana() {
      this.mostrarVentanaEditarUsuario = false;
      this.estaLicitacion = null;
    },
  },
};
</script>

<style lang="scss">

</style>
